
































import {Component, Watch} from "vue-property-decorator";
    import EnumSelector from "@/shared/components/EnumSelector/index.vue";
    import {CommonStatus} from "@/enums/status";
    import {EmployeeType} from "@/enums/type";
    import {assignValueToForm} from "@/shared/services/helper/utils";
    import {EmployeeStore} from "@/modules/employees/store";
    import debounce from "lodash/debounce";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
    import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

    @Component({
        name: "EmployeeSearch",
        components: {PostOfficeSelector, EnumSelector}
    })
    export default class extends mixins(CommonMixin) {
        CommonStatus = CommonStatus;
        EmployeeType = EmployeeType;
        form = {
            search: "",
            type: undefined,
            status: undefined,
            postOfficeRowGuid: undefined
        };

        @Watch('form', { immediate: false, deep: true })
        onValuesChange(val: any) {
            this.handleChange(val);
        }

        handleChange = debounce(function (val) {
            const params = { ...val, page: 1 };
            EmployeeStore.updateEmployeeParams(params);
            EmployeeStore.listEmployee({ params, refresh: true });
        }, 500);
    }
